var _g, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLevel1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 42,
    viewBox: "0 0 40 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5468_3505)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 21,
    r: 18,
    fill: "#ECF9FE"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.7676 31H9.23188C8.55159 31 8 31.6716 8 32.5C8 33.3284 8.55159 34 9.23188 34H30.7681C31.4484 34 32 33.3284 32 32.5C32 31.6716 31.4479 31 30.7676 31Z",
    fill: "url(#paint0_linear_5468_3505)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0404 12.9043C32.8829 12.9043 31.945 13.8423 31.945 14.9997C31.945 15.5797 32.1807 16.1044 32.5611 16.4837L26.0512 19.9398L20.9408 10.3653C21.7612 10.023 22.3381 9.21415 22.3381 8.26992C22.3381 7.01634 21.3217 6 20.0681 6C18.8146 6 17.7982 7.01634 17.7982 8.26992C17.7982 9.21415 18.3751 10.0236 19.1955 10.3653L14.085 19.9398L7.57523 16.4837C7.95564 16.1044 8.1913 15.5797 8.1913 14.9997C8.1913 13.8423 7.25334 12.9043 6.09591 12.9043C4.93848 12.9043 4 13.8423 4 14.9997C4 16.1572 4.93796 17.0951 6.09539 17.0951C6.14503 17.0951 6.19415 17.0909 6.24327 17.0878L8.63623 29H31.5288L33.893 17.0878C33.9421 17.0915 33.9907 17.0951 34.0409 17.0951C35.1983 17.0951 36.1363 16.1572 36.1363 14.9997C36.1363 13.8423 35.1978 12.9043 34.0404 12.9043Z",
    fill: "url(#paint1_linear_5468_3505)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1095 25.6099C17.6667 25.6099 17.4453 25.3926 17.4453 24.9578C17.4453 24.5392 17.6667 24.3299 18.1095 24.3299H19.4619V18.8596L18.4355 19.4755C18.2423 19.5882 18.0652 19.6164 17.9042 19.56C17.7512 19.5037 17.6345 19.403 17.554 19.2581C17.4735 19.1132 17.4493 18.9563 17.4815 18.7872C17.5137 18.6101 17.6264 18.4652 17.8197 18.3525L19.4861 17.3502C19.6471 17.2536 19.8081 17.1731 19.9691 17.1087C20.1301 17.0362 20.2791 17 20.4159 17C20.585 17 20.7259 17.0483 20.8386 17.1449C20.9513 17.2335 21.0076 17.3824 21.0076 17.5917V24.3299H22.2393C22.6821 24.3299 22.9035 24.5392 22.9035 24.9578C22.9035 25.3926 22.6821 25.6099 22.2393 25.6099H18.1095Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5468_3505",
    x: 0,
    y: 2,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5468_3505"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5468_3505",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5468_3505",
    x1: 19.9999,
    y1: 30.1792,
    x2: 19.9919,
    y2: 33.5063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57D98B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3EBCC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5468_3505",
    x1: 20.0679,
    y1: -0.292792,
    x2: 19.7209,
    y2: 25.2107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57D98B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3EBCC4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel1);
export default __webpack_public_path__ + "static/media/level1.3bdfd8a3414266980ee76d62039bd58b.svg";
export { ForwardRef as ReactComponent };